<template>
  <div
    :style="{ width: $vw(listWidth), height: $vw(listHeight) }"
  >
    <van-pull-refresh
      v-model="handleRefreshing"
      class="via-plugin-list-box"
      :style="{ width: $vw(listWidth), height: $vw(listHeight) }"
      @refresh="refresh"
    >
      <van-list
        v-model="handleLoading"
        :finished="handleFinished"
        :finished-text="list.length == 0 ? '一条也没有' : '没有更多了'"
        @load="listLoad"
      >
        <div
          v-if="skeleton && !firstLoadFinished"
          slot="loading"
        />
        <van-skeleton
          v-if="list"
          class="via-plugin-list-skeleton"
          title
          :row="listHeight / 35"
          :loading="skeleton ? !firstLoadFinished : false"
        >
          <template v-if="list.length > 0">
            <div
              v-for="item in list"
              :key="item.id"
              class="via-plugin-list-card"
            >
              <div
                class="plugin-icon-box"
                :style="{ backgroundColor: item.iconBgColor || 'var(--light40)' }"
              >
                <van-icon
                  class="plugin-icon"
                  :size="$vw('30px')"
                  class-prefix="icon"
                  :color="item.iconColor || '#fff'"
                  :name="item.icon"
                />
              </div>
              <div class="plugin-right">
                <div class="plugin-title">
                  {{ item.name }}
                </div>
                <div class="plugin-author">
                  {{ item.author && item.author.nickname }}
                </div>
                <div class="plugin-update-time">
                  更新：{{ item.updateTime | timeFormat(1) }}
                </div>
              </div>
              <van-button
                class="plugin-link-btn"
                type="primary"
                @click="goToPluginDetail(item.id)"
              >查看</van-button>
            </div>
          </template>
          <template v-if="list.length === 0 && !handleLoading && !handleRefreshing">
            <div
              class="via-plugin-list-nothing"
              :style="{ width: $vw(listWidth), height: $vw(lottieBoxHeight) }"
            >
              <!-- 动画 -->
              <via-lottie
                :animation-data="animationData"
                :height="lottieHeight"
                :width="lottieWidth"
              />
            </div>
          </template>
        </van-skeleton>
        <slot
          v-else
          name="plugin"
        />
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import ViaLottie from 'components/common/via-lottie'
import * as animationData from 'static/lottie/lottie-404.json'
import { PullRefresh, Button, Skeleton } from 'vant'
import { timeFormat } from '~/utils/filters'

export default {
  name: 'ViaPluginList',
  filters: {
    timeFormat
  },
  components: {
    [PullRefresh.name]: PullRefresh,
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [ViaLottie.name]: ViaLottie
  },
  props: {
    // 列宽rpx
    width: {
      type: [String, Number],
      default: null
    },
    // 列表高rpx
    height: {
      type: [String, Number],
      default: null
    },
    // 第一次加载是否开启骨架屏
    skeleton: {
      type: Boolean,
      default: true
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    finished: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      animationData: animationData.default,
      firstLoadFinished: false,
      handleRefreshing: false,
      handleLoading: false,
      handleFinished: false
    }
  },
  computed: {
    // return rpx
    listWidth() {
      const defaultWidth = 375
      return this.width ? this.width : defaultWidth
    },
    // return rpx
    listHeight() {
      const navHeight = 46
      const clientHeight = this.$pxToRpx(this.$clientHeight)
      const defaultHeight = clientHeight - navHeight
      return this.height ? this.height : defaultHeight
    },
    // return rpx
    lottieBoxHeight() {
      return this.listHeight - 49
    },
    // return rpx
    lottieWidth() {
      return this.listWidth
    },
    // return rpx
    lottieHeight() {
      return this.listHeight * 0.5
    }
  },
  watch: {
    refreshing: {
      immediate: true, // 这句重要
      handler(newValue, oldValue) {
        if (this.handleRefreshing !== this.refreshing) {
          this.handleRefreshing = newValue
        }
      }
    },
    loading: {
      immediate: true, // 这句重要
      handler(newValue, oldValue) {
        // console.log('1、loading', newValue);
        // console.log('1、handleLoading', this.handleLoading);
        if (this.loading !== this.handleLoading) {
          this.handleLoading = newValue
          !newValue && (this.firstLoadFinished = true)
        }
      }
    },
    finished: {
      immediate: true, // 这句重要
      handler(newValue, oldValue) {
        if (this.finished !== this.handleFinished) {
          this.handleFinished = newValue
        }
      }
    }
  },
  methods: {
    refresh() {
      this.$emit('update:refreshing', true)
      this.$emit('refresh')
    },
    listLoad() {
      // console.log('2、loading', this.loading);
      // console.log('2、handleLoading', this.handleLoading);
      this.$emit('update:loading', true)
      this.$emit('load')
    },
    goToPluginDetail(id) {
      this.$router.$push({
        name: 'PluginDetail',
        params: {
          id
        }
      })
    }
  }
}
</script>

<style scoped>
.via-plugin-list-box {
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}
.via-plugin-list-card {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 80px;
    background-color: var(--light100);
    box-sizing: border-box;
    margin: 15px 0;
}
.via-plugin-list-card .plugin-icon-box {
    width: 50px;
    height: 50px;
    border-radius: 15px;
    margin-left: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.via-plugin-list-card .plugin-right {
    position: relative;
    max-width: 285px;
    height: 100%;
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.via-plugin-list-card .plugin-title {
    font-size: 14px;
    font-weight: 900;
}
.via-plugin-list-card .plugin-author {
    font-size: 12px;
    color: var(--light50);
    margin: 4px 0;
}
.via-plugin-list-card .plugin-update-time {
    font-size: 12px;
    color: var(--light50);
}
.via-plugin-list-card .plugin-link-btn {
    width: 60px;
    height: 30px;
    border-radius: 15px;
    position: absolute;
    top: 25px;
    right: 15px;
    line-height: 30px;
    font-size: 12px;
}
.via-plugin-list-nothing {
    display: flex;
    justify-content: center;
    align-items: center;
}
.via-plugin-list-skeleton {
    margin-top: 30px;
}
</style>
